// extracted by mini-css-extract-plugin
export default {"tokenContainer":"TokenInput_tokenContainer__fWukU","resendText":"TokenInput_resendText__k3aG4"};